/**** session clear when user enter from menue start  ****/
setTimeout(function(){        
    jQuery(".mega-menu__linklist-link").click(function() {     
      localStorage.clear();
    });   
}, 1600); 